var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlAccessibilityOutlined = function SvgHtlAccessibilityOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.02 11.381a4.04 4.04 0 0 1 2.535-4.265.5.5 0 0 1 .364.931 3.04 3.04 0 0 0-1.906 3.212 3.064 3.064 0 0 0 5.56 1.364.502.502 0 0 1 .905.19.5.5 0 0 1-.078.374 4.05 4.05 0 0 1-3.356 1.763 4.066 4.066 0 0 1-4.024-3.569Zm8.906 3.012L10.79 11H8.149a.5.5 0 0 1-.493-.419l-.972-5.832a2 2 0 0 1-1.035-1.75 2.006 2.006 0 0 1 2-2 2.006 2.006 0 0 1 2 2 2.006 2.006 0 0 1-1.91 2l.5 3h2.41a.5.5 0 0 1 0 1H8.406l.167 1h2.576a.5.5 0 0 1 .474.341l1.25 3.734a.5.5 0 0 1-.947.319ZM6.65 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z"
  })));
};
export default SvgHtlAccessibilityOutlined;